import React from "react";
import MuiDialog from "@mui/material/Dialog";

import { DialogProps } from "./Dialog.types";
import DialogContext from "./DialogContext";
import { useDialogStyles } from "./Dialog.styles";
import { Slide } from "@mui/material";
import { TransitionProps } from "@mui/material/transitions";
import useBreakpoints from "../hooks/useBreakpoints";

function Dialog(props: DialogProps) {
  const { onClose, closeDisabled, disableBackdropClose, ...other } = props;

  const { mdUp } = useBreakpoints();

  const dialogClasses = useDialogStyles(props);

  const handleClose = React.useCallback(
    (event?: any, reason?: "backdropClick" | "escapeKeyDown") => {
      if (disableBackdropClose && reason === "backdropClick") {
        return;
      }
      if (onClose) {
        onClose();
      }
    },
    [disableBackdropClose, onClose]
  );

  const contextValue = React.useMemo(() => {
    return {
      onClose: handleClose,
      closeDisabled,
    };
  }, [handleClose, closeDisabled]);

  return (
    <DialogContext.Provider value={contextValue}>
      <MuiDialog
        {...other}
        classes={dialogClasses}
        onClose={handleClose}
        TransitionComponent={mdUp ? undefined : Transition}
      />
    </DialogContext.Provider>
  );
}

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children: React.ReactElement<any, any> },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default Dialog;
